import request from './../../../utilities/request';
import localStorageToken from './../../../utilities/storage';

function get(log) {
  return request({
    url:    `/logger/read/${ log }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function getFilenames() {
  return request({
    url:    `/logger/filenames`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

const LogService = {
  get,
  getFilenames
}

export default LogService;
